import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-certificate',
  templateUrl: './transfer-certificate.component.html',
  styleUrls: ['./transfer-certificate.component.scss']
})
export class TransferCertificateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
